/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface APIResponseBase
 */
export interface APIResponseBase {
    /**
     * 
     * @type {APIMeta}
     * @memberof APIResponseBase
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof APIResponseBase
     */
    errors?: Array<APIResponseError>;
}

/**
 * Check if a given object implements the APIResponseBase interface.
 */
export function instanceOfAPIResponseBase(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function APIResponseBaseFromJSON(json: any): APIResponseBase {
    return APIResponseBaseFromJSONTyped(json, false);
}

export function APIResponseBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIResponseBase {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
    };
}

export function APIResponseBaseToJSON(value?: APIResponseBase | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
    };
}

